import { polyfill } from "es6-promise";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

polyfill();
